<script setup>
    import InputHeader from '@/js/components/Common/InputHeader.vue'
    import { onMounted, ref } from 'vue'
    import { TextField } from '@/js/components/Common'

    const props = defineProps({
        user: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['user-saved'])
    const editUser = ref({})

    const resetEditUser = function () {
        editUser.value.titel = props.user?.titel
        editUser.value.vorname = props.user?.vorname
        editUser.value.nachname = props.user?.nachname
        editUser.value.email = props.user?.email.email
    }

    const handleUserUpdate = () => {
        emit('user-saved', editUser.value)
    }

    onMounted(() => {
        resetEditUser()
    })
</script>

<template>
    <div class="d-flex flex-column">
        <!--        <SingleEdit-->
        <!--            title="Titel"-->
        <!--            :entry="user.titel"-->
        <!--            :allow-edit="true"-->
        <!--        />-->
        <!--        <SingleEdit-->
        <!--            title="Vorname"-->
        <!--            :entry="editUser.vorname"-->
        <!--            :allow-edit="true"-->
        <!--            @text-saved="(newVorname) => editUser.vorname = newVorname"-->
        <!--            @edit-aborted="() => editUser.vorname = props.user.vorname"-->
        <!--        />-->
        <!--        <SingleEdit-->
        <!--            title="Nachname"-->
        <!--            :entry="user.nachname"-->
        <!--            :allow-edit="true"-->
        <!--        />-->
        <!--        <SingleEdit-->
        <!--            title="Email"-->
        <!--            :entry="user.email.email"-->
        <!--            :allow-edit="true"-->
        <!--        />-->
        <div class="d-flex w-100 flex-nowrap">
            <input-header title="Titel" />
            <text-field v-model="editUser.titel" label="Titel" class="w-100 h-auto rounded-0" />
        </div>
        <div class="d-flex w-100 flex-nowrap">
            <input-header title="Vorname" />
            <text-field v-model="editUser.vorname" class="w-100 h-auto rounded-0" />
        </div>
        <div class="d-flex w-100 flex-nowrap">
            <input-header title="Nachname" />
            <text-field v-model="editUser.nachname" class="w-100 h-auto rounded-0" />
        </div>

        <div class="d-flex w-100 flex-nowrap">
            <input-header title="Email" />
            <text-field v-model="editUser['email']" class="w-100 h-auto rounded-0" />
        </div>

        <div class="mt-4 d-flex flex-row-reverse justify-content-between">
            <v-btn type="submit" color="primary" @click="handleUserUpdate()"> Speichern </v-btn>
            <v-btn type="reset" color="secondary" @click="resetEditUser"> Reset </v-btn>
        </div>
    </div>
</template>

<style scoped lang="scss"></style>
